<div class="page-header-container">
    <div class="page-title">
        {{'requests.clientData.newRequest.Title' | translate}}
    </div>
</div>

<div class="wizard-container">
    <button class="btn link-btn btn-back-txt" (click)="redirectFieldSelectionHandler()">
        <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
        <span>{{'requests.clientData.newRequest.Back' | translate}}</span>
    </button>

    <div class="row">
        <span class="col-12 d-flex justify-content-center title">{{'requests.clientData.newRequest.ownerInformation.Title' | translate}}</span>
    </div>

    <form #form="ngForm" >
        <div class="row justify-content-around">
            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 input-col">
                <label class="text-field-label">{{'requests.clientData.newRequest.ownerInformation.Name' | translate}} <span class="text-primary fw-bold">*</span>
                </label>
      
                <input kendoTextBox 
                    class="text-input" 
                    [(ngModel)]="clientDataRequestSaveModel.beneficialOwner.name" 
                    required 
                    name="beneficialOwnerName"
                    #beneficialOwnerName="ngModel"/>
                <div class="error-info" *ngIf="beneficialOwnerName.invalid  && (beneficialOwnerName.dirty || form.submitted)">
                    <div  *ngIf="beneficialOwnerName.errors?.['required']">
                        {{'common.validation.required' | translate}}
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 input-col">
                <label class="text-field-label">{{'requests.clientData.newRequest.contactInformation.Phone' | translate}} <span class="text-primary fw-bold">*</span>
                </label>       
                <input kendoTextBox 
                    class="text-input" 
                    type="number" 
                    [(ngModel)]="clientDataRequestSaveModel.beneficialOwner.phone" 
                    required 
                    name="phone"
                    #phone="ngModel"/>
                <div class="error-info" *ngIf="phone.invalid  && (phone.dirty || form.submitted)">
                    <div  *ngIf="phone.errors?.['required']">
                        {{'common.validation.required' | translate}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center mt-4">
            <div class="col-9">
                <client-data-request-uploader 
                    [clientDataRequest]="clientDataRequestSaveModel" 
                    [deleteFileHandler]="_filesHandler.deleteFileHandler"
                    [uploadFilesHandler]="_filesHandler.uploadFilesHandler">
                </client-data-request-uploader>
            </div>
        </div>

        <div class="d-flex justify-content-center mt-5">
            <button class="btn primary-btn px-5" 
                (click)="sendRequestCofirmationHandler()" 
                [disabled]="isSendButtonDisabled">
                <span>
                    {{ 'requests.clientData.newRequest.Next' | translate}}
                </span>
            </button>
        </div>
    </form>
</div>
